import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newAccount() {
    let accounttypeDetails = {
      account_name: $(".account_name").val()
    };
    $(".creatingAccounttype").hide();
    $(".creatingAccounttypeLoader").show();
    baseurl.post(rt.newAccount, accounttypeDetails).then(res => {
      $(".creatingAccounttype").show();
      $(".creatingAccounttypeLoader").hide();
      $(".form-control").val("");

      //checking response code from backend api

      if (res.data.code === 200) {
        //success codes
        suc.accounttypeCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //account name exits code
        ers.AccounttypeExists();
      } else if (res.data.code === 404) {
        //error on inserting data
        ers.errorCreatingAccounttype();
      } else if (res.data.code === 405) {
        //no permission to create data
        ers.noPermissionToCreate();
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadAccounttypes({ commit }) {
    baseurl.get(rt.loadAccounttype).then(res => {
      $(".accounttypesLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success codes and mutations
        commit("STORE_ACCOUNTTYPES", res.data.accounttypes);
      } else if (res.data.code === 404) {
        //error on loading data
        ers, ers.errorLoadingAccounttype();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
        commit("STORE_ACCOUNTTYPES", []);
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },
  viewAccounttype({ commit }, accounttypeId) {
    commit("STORE_ACCOUNTTYPE_UPDATE", accounttypeId);
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/accounttypes/actions.js